module.exports = "<div>\r\n\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/forms/directives/item/item.html
// module id = 3444
// module chunks = 0